import { Component, Input } from '@angular/core';

@Component({
    selector: 'anp-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent {
  @Input() public link: string;
  @Input() public title = 'PSP';
}
